<template>
  <article
    v-if="currentStep !== 1"
    class="container stepper"
  >
    <article class="checklist__desktop">
      <article class="checklist__desktop-infos">
        <h2 class="checklist__desktop-stepName">
          {{ currentStep - 1 }}. {{ currentStepName }}
        </h2>
        <p class="checklist__desktop-stepDescription">
          {{ currentStepDescription }}
        </p>
      </article>
    </article>
    <article class="checklist__mobile">
      <article class="checklist__mobile-header">
        <p class="checklist__mobile-stepName">
          {{ currentStepName }}
        </p>
        <p class="checklist__mobile-steps">
          <span><b>{{ currentStep - 1 }}</b> / {{ steps }}</span>
        </p>
      </article>
    </article>
  </article>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'StepperChecklist',
  data() {
    return {
      steps: 4,
    };
  },
  computed: {
    ...mapGetters(['currentStep', 'stepsIsCompleted']),
    currentStepName() {
      switch (this.currentStep) {
        case 1:
          return this.$t('STEPPER.ONE.title');
        case 2:
          return this.$t('STEPPER.TWO.title');
        case 3:
          return this.$t('STEPPER.THREE.title');
        case 4:
          return this.$t('STEPPER.FOUR.title');
        case 5:
          return this.$t('STEPPER.FIVE.title');
        default:
          return '';
      }
    },

    currentStepDescription() {
      switch (this.currentStep) {
        case 1:
          return this.$t('STEPPER.ONE.description');
        case 2:
          return this.$t('STEPPER.TWO.description');
        case 3:
          return this.$t('STEPPER.THREE.description');
        case 4:
          return this.$t('STEPPER.FOUR.description');
        case 5:
          return this.$t('STEPPER.FIVE.description');
        default:
          return '';
      }
    },
  },

  methods: {
    ...mapActions(['saveCurrentStep']),

    itemClass(step) {
      if (this.currentStep === step) return 'active';
      if (this.stepsIsCompleted[step]) return 'completed';

      return '';
    },

    changeCurrentStep(step) {
      if (this.stepsIsCompleted[step]) this.saveCurrentStep(step);
    },

    stepsTitle(currentStep) {
      switch (currentStep) {
        case 1:
          return this.$t('STEPPER.ONE.title');
        case 2:
          return this.$t('STEPPER.TWO.title');
        case 3:
          return this.$t('STEPPER.THREE.title');
        case 4:
          return this.$t('STEPPER.FOUR.title');
        case 5:
          return this.$t('STEPPER.FIVE.title');
        default:
          return '';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.stepper {
  padding-left: 0;
  padding-right: 0;

  @include screen(tablet-up) {
    border-top: $border-1 solid #d8d8d8;
    border-bottom: $border-1 solid #d8d8d8;
    padding: 0 8%;

    @include make-accessible($white, $secondary-accessibility, background-color);
  }
}

.checklist__mobile {
  width: 100%;
  height: auto;
  display: flex;
  background: $white;

  @include screen(tablet-up) {
    display: none;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: $text-xs;
  }
}

.checklist__desktop {
  display: none;

  @include screen(tablet-up) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 1.5rem;
    transition: 0.2s all ease;
  }

  &-infos {
    font-size: $text-sm;
  }

  &-stepName {
    font-family: $montserrat-bold;

    @include make-accessible($primary, $white, color);
  }

  &-stepDescription {
    @include make-accessible($gray-60, $white, color);
  }
}
</style>
